<template>
  <div class="location" v-if="text && images">
    <base-dialog
      :show="!!error"
      title="An error occurred!"
      @close="handleError"
      fixed
    >
      <p>{{ error }}</p>
    </base-dialog>
    <the-header></the-header>
    <base-page-heading
        :title="text['location-main-title']"
        :copy="text['location-main-copy']"
        class="px-6"
      ></base-page-heading>
    <div class="relative mb-20">
      <div class="container mx-auto md:px-6 relative w-full">
        <div class="absolute h-full w-full">
          <div class="flex flex-wrap">
            <div class="flex-auto text-center mt-3">
              <button class="btn-outline-white active" content="test">
                London
              </button>
              <button class="btn-outline-white mx-2">Local</button>
              <button class="btn-outline-white">Masterplan</button>
            </div>
          </div>
          <div id="map-panel" v-if="$mq === 'md' || $mq === 'lg'">
            <div class="flex">
              <div class="flex-auto switch-text">Green spaces</div>
              <div class="flex justify-items-end items-center">
                <label class="switch">
                    <input type="checkbox" v-model="pins.greenspaces">
                    <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="flex">
              <div class="flex-auto switch-text">Transport</div>
              <div class="flex justify-items-end items-center">
                <label class="switch">
                    <input type="checkbox" v-model="pins.transport">
                    <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="flex">
              <div class="flex-auto switch-text">Dining</div>
              <div class="flex justify-items-end items-center">
                <label class="switch">
                    <input type="checkbox">
                    <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="flex">
              <div class="flex-auto switch-text">Leisure</div>
              <div class="flex justify-items-end items-center">
                <label class="switch">
                    <input type="checkbox">
                    <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="flex">
              <div class="flex-auto switch-text">Education</div>
              <div class="flex justify-items-end items-center">
                <label class="switch">
                    <input type="checkbox">
                    <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div v-if="$mq === 'md' || $mq === 'lg'">
          <img
            class="absolute"
            style="top:24%;left:38.4%;"
            width="75"
            src="data:image/svg+xml;base64,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"
          />
          <div v-if="pins.greenspaces">
            <button class="dot" style="left:46%;top:29%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content='`<h3 class="text-dark">Hampstead Heath</h3><p class="text-orange">0.6 miles</p>`'></button>
            <button class="dot" style="left:46.5%;top:48%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content='`<h3 class="text-dark">Regents Park</h3><p class="text-orange">2.7 miles</p>`'></button>
            <button class="dot" style="left:41.5%;top:62.5%;" v-tippy='{placement: "left", interactive: true, trigger: "click", allowHTML: true}' :content='`<h3 class="text-dark">Hyde Park</h3><p class="text-orange">3.7 miles</p>`'></button>
            <button class="dot" style="left:49.5%;top:64.5%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content='`<h3 class="text-dark">Green Park</h3><p class="text-orange">4.7 miles</p>`'></button>
          </div>
          <div v-if="pins.transport">
            <button class="dot" style="left:54%;top:47%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content="`<h3 class='text-dark'>King's Cross St Pancras</h3><div style='color:#FDCB4C;'><div class='map-line-color' style='border-color:#FDCB4C;background-color:#FDCB4C;'></div>Circle</div>
    <div style='color:#FFBED2;'><div class='map-line-color' style='border-color:#FFBED2;background-color:#FFBED2;'></div>Hammersmith & City</div>
    <div style='color:#5C29C7;'><div class='map-line-color' style='border-color:#5C29C7;background-color:#5C29C7;'></div>Metropolitan</div>
    <div style='color:#000;'><div class='map-line-color' style='border-color:#000;background-color:#000;'></div>Northern</div>
    <div style='color:#053BF9;'><div class='map-line-color' style='border-color:#053BF9;background-color:#053BF9;'></div>Piccadilly</div>
    <div style='color:#13C9F1;'><div class='map-line-color' style='border-color:#13C9F1;background-color:#13C9F1;'></div>Victoria</div>`"></button>
            <button class="dot" style="left:41%;top:32%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content="`<h3 class='text-dark'>Hampstead</h3><div style='color:#000;'><div class='map-line-color' style='border-color:#000;background-color:#000;'></div>Northern</div>`"></button>
            <button class="dot" style="left:42%;top:55%;" v-tippy='{placement: "left", interactive: true, trigger: "click", allowHTML: true}' :content="`<h3 class='text-dark'>Paddington</h3><div style='color:#FDCB4C;'><div class='map-line-color' style='border-color:#FDCB4C;background-color:#FDCB4C;'></div>Circle</div>
  <div style='color:#FFBED2;'><div class='map-line-color' style='border-color:#FFBED2;background-color:#FFBED2;'></div>Hammersmith & City</div>
  <div style='color:#0d611f;'><div class='map-line-color' style='border-color:#0d611f;background-color:#0d611f;'></div>District</div>
  <div style='color:#753c1c;'><div class='map-line-color' style='border-color:#753c1c;background-color:#753c1c;'></div>Bakerloo</div>`"></button>
          </div>
        </div>
        <img
          id="map"
          v-if="$mq === 'md' || $mq === 'lg'"
          src="../assets/London_Map_2K.jpg"
          class="w-full"
        />
      </div>
      <div id="map-panel" v-if="$mq === 'sm'">
        <div class="flex">
          <div class="flex-auto switch-text">Green spaces</div>
          <div class="flex justify-items-end items-center">
            <label class="switch">
                <input type="checkbox" v-model="pins.greenspaces">
                <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="flex">
          <div class="flex-auto switch-text">Transport</div>
          <div class="flex justify-items-end items-center">
            <label class="switch">
                <input type="checkbox" v-model="pins.transport">
                <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="flex">
          <div class="flex-auto switch-text">Dining</div>
          <div class="flex justify-items-end items-center">
            <label class="switch">
                <input type="checkbox">
                <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="flex">
          <div class="flex-auto switch-text">Leisure</div>
          <div class="flex justify-items-end items-center">
            <label class="switch">
                <input type="checkbox">
                <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="flex">
          <div class="flex-auto switch-text">Education</div>
          <div class="flex justify-items-end items-center">
            <label class="switch">
                <input type="checkbox">
                <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div v-if="$mq === 'sm'">
        <img
          class="absolute"
          style="top:25%;left:14.4%;"
          width="75"
          src="data:image/svg+xml;base64,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"
        />
        <div v-if="pins.greenspaces">
          <button class="dot" style="left:38%;top:29%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content='`<h3 class="text-dark">Hampstead Heath</h3><p class="text-orange">0.6 miles</p>`'></button>
          <button class="dot" style="left:39.5%;top:48%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content='`<h3 class="text-dark">Regents Park</h3><p class="text-orange">2.7 miles</p>`'></button>
          <button class="dot" style="left:23.5%;top:62.5%;" v-tippy='{placement: "left", interactive: true, trigger: "click", allowHTML: true}' :content='`<h3 class="text-dark">Hyde Park</h3><p class="text-orange">3.7 miles</p>`'></button>
          <button class="dot" style="left:49.5%;top:64.5%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content='`<h3 class="text-dark">Green Park</h3><p class="text-orange">4.7 miles</p>`'></button>
        </div>
        <div v-if="pins.transport">
          <button class="dot" style="left:64%;top:47%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content="`<h3 class='text-dark'>King's Cross St Pancras</h3><div style='color:#FDCB4C;'><div class='map-line-color' style='border-color:#FDCB4C;background-color:#FDCB4C;'></div>Circle</div>
  <div style='color:#FFBED2;'><div class='map-line-color' style='border-color:#FFBED2;background-color:#FFBED2;'></div>Hammersmith & City</div>
  <div style='color:#5C29C7;'><div class='map-line-color' style='border-color:#5C29C7;background-color:#5C29C7;'></div>Metropolitan</div>
  <div style='color:#000;'><div class='map-line-color' style='border-color:#000;background-color:#000;'></div>Northern</div>
  <div style='color:#053BF9;'><div class='map-line-color' style='border-color:#053BF9;background-color:#053BF9;'></div>Piccadilly</div>
  <div style='color:#13C9F1;'><div class='map-line-color' style='border-color:#13C9F1;background-color:#13C9F1;'></div>Victoria</div>`"></button>
          <button class="dot" style="left:22%;top:32%;" v-tippy='{placement: "right", interactive: true, trigger: "click", allowHTML: true}' :content="`<h3 class='text-dark'>Hampstead</h3><div style='color:#000;'><div class='map-line-color' style='border-color:#000;background-color:#000;'></div>Northern</div>`"></button>
          <button class="dot" style="left:25%;top:55%;" v-tippy='{placement: "left", interactive: true, trigger: "click", allowHTML: true}' :content="`<h3 class='text-dark'>Paddington</h3><div style='color:#FDCB4C;'><div class='map-line-color' style='border-color:#FDCB4C;background-color:#FDCB4C;'></div>Circle</div>
<div style='color:#FFBED2;'><div class='map-line-color' style='border-color:#FFBED2;background-color:#FFBED2;'></div>Hammersmith & City</div>
<div style='color:#0d611f;'><div class='map-line-color' style='border-color:#0d611f;background-color:#0d611f;'></div>District</div>
<div style='color:#753c1c;'><div class='map-line-color' style='border-color:#753c1c;background-color:#753c1c;'></div>Bakerloo</div>`"></button>
        </div>
      </div>
      <img
        id="map-sm"
        v-if="$mq === 'sm'"
        src="../assets/London_Map_cropped.jpg"
        class="w-full"
      />
    </div>
    <base-content> 
      <div class="grid grid-cols-1 md:grid-cols-2 lg:gap-x-24 md:gap-x-9 mb-14">
        <div class="mt-10">
          <img
            :src="images['location-neighbourhood-image'].large"
            class="img-col"
          />
          <h3 class="text-2xl mt-10 mb-6">
            {{ text["location-neighbourhood-title"] }}
          </h3>
          <p>{{ text["location-neighbourhood-copy"] }}</p>
        </div>
        <div class="mt-10 md:mt-0">
          <img :src="images['location-green-image'].large" class="img-col" />
          <h3 class="text-2xl mt-10 mb-6">
            {{ text["location-green-title"] }}
          </h3>
          <p>{{ text["location-green-copy"] }}</p>
        </div>
        <div class="mt-10">
          <img
            :src="images['location-lifestyle-image'].large"
            class="img-col"
          />
          <h3 class="text-2xl mt-10 mb-6">
            {{ text["location-lifestyle-title"] }}
          </h3>
          <p>{{ text["location-lifestyle-copy"] }}</p>
        </div>
        <div class="mt-10 md:mt-0">
          <img
            :src="images['location-education-image'].large"
            class="img-col"
          />
          <h3 class="text-2xl mt-10 mb-6">
            {{ text["location-education-title"] }}
          </h3>
          <p>{{ text["location-education-copy"] }}</p>
        </div>
      </div>
    </base-content>
    <the-footer></the-footer>
  </div>
</template>

<script>
export default {
  name: "Location",
  data() {
    return {
      isLoading: false,
      error: null,
      pins: {
        greenspaces: false,
        transport: false
      }
    };
  },
  computed: {
    text() {
      return this.$store.getters["categories/text"];
    },
    images() {
      return this.$store.getters["categories/images"];
    },
  },
  beforeCreate: function() {
    document.body.className = "bg-white";
  },
  created() {
    this.loadCategories();
  },
  methods: {
    async loadCategories(refresh = false) {
      this.isLoading = true;
      try {
        await this.$store.dispatch("categories/loadCategories", {
          forceRefresh: refresh,
        });
      } catch (error) {
        this.error = error.message || "Something went wrong!";
      }
      this.isLoading = false;
    },
    handleError() {
      this.error = null;
    },
  },
};
</script>

<style scoped>
.img-col {
  height: 450px;
  width: 100%;
  object-fit: cover;
}

button.btn-outline-white {
  color: #fff;
  border: 2px solid #fff;
  border-radius: 5px;
  background-color: #d7d2cb;
  box-shadow: 0px 0px 15px 0px #999;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  font-weight: 400;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

button.active {
  color: #2d2926;
  background-color: #fff;
  border-color: #fff;
  font-family: "Circular Black", sans-serif;
}

#map-panel {
  position: absolute;
  z-index: 70;
  left: 20px;
  bottom: 20px;
  border: #fff;
  box-shadow: 0px 0px 15px 0px #999;
  border-radius: 5px;
  background-color: #fff;
  right: 20px;
  padding: 1rem;
}

@media (min-width: 768px) {
  #map-panel {
    right: unset;
    width: 300px;
  }
}

.dot {
  height: 20px;
  width: 20px;
  background-color: #FFF;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  box-shadow: 0px 0px 15px 0px #999;
  border: 0px;
  font-size: 10px;
}

.dot:focus {
  outline: none;
}

/* Map Switches */
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 28px;
  margin:0;
}

.switch-text {
  font-family: 'Circular Black';
  line-height: 36px;
  font-size: 18px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #FFF;
  -webkit-transition: .4s;
  transition: .4s;
  border: 2px solid #2d2926;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: #2d2926;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  border-color: #FE5000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
  background-color: #FE5000;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
